
































































































































import { Component } from "vue-property-decorator";
import SingleFileHolder from "@/components/new_style_components/SingleFileHolder.vue";
import PortalCheckbox from "@/components/new_style_components/PortalCheckbox.vue";
import DictionarySelect from "@/components/new_style_components/DictionarySelect.vue";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import PortalTextarea from "@/components/new_style_components/PortalTextarea.vue";
import SublimeSearch from "@/components/new_style_components/SublimeSearch.vue";
import PRIL_DTO from "@/dto/request/pril/PRIL_DTO";
import Application from "@/state/Application";
import PRILService from "@/services/request/PRILService";
import { processError } from "@/utils/ComponentUtils";
import PRILExtension from "@/mixins/PRILExtension";
import { prettyEnum } from "@/utils/StringUtils";
import moment from "moment";
import EditPRILPayload from "@/dto/request/pril/EditPRILPayload";
import AddPRILCommentPayload from "@/dto/request/pril/AddPRILCommentPayload";
import AddPRILAdditionalFileModal from "@/components/pril/AddPRILAdditionalFileModal.vue";
import ChangeCompanyModal from "@/components/pril/ChangeCompanyModal.vue";
import { PRILStatus } from "@/constants/request/PRILConstants";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import FileService from "@/services/FileService";

@Component({
  components: {
    PortalTextarea,
    PortalSelect,
    DictionarySelect,
    PortalCheckbox,
    SingleFileHolder,
    SublimeSearch,
    AddPRILAdditionalFileModal,
    ChangeCompanyModal,
  },
  computed: {
    moment() {
      return moment
    }
  },
  methods: {
    prettyEnum
  }
})
export default class PRIL extends PRILExtension {

  private pril: PRIL_DTO | null = null;
  private prilPayload = new EditPRILPayload();
  private prilCommentPayload = new AddPRILCommentPayload();

  async mounted(): Promise<void> {
    await this.loadPRIL();
  }

  loadPRIL(): void {
    Application.startLoading();
    PRILService.getLetterById(this.prilId).then(
      resp => {
        this.pril = resp.data;
        this.prilPayload.status = this.pril.status;
        Application.stopLoading();
      },
      error => processError(error, this)
    )
  }

  setStatus(): void {
    Application.startLoading();
    PRILService.updateLetterStatus(this.prilId, this.prilPayload.status as PRILStatus).then(
      resp => {
        this.loadPRIL();
      },
      error => processError(error, this)
    )
  }

  addComment(): void {
    Application.startLoading();
    PRILService.addComment(this.prilId, this.prilCommentPayload).then(
      resp => {
        this.prilCommentPayload = new AddPRILCommentPayload();
        this.loadPRIL();
      },
      error => processError(error, this)
    )
  }

  get prilId(): number {
    return Number.parseInt(this.$route.params.id);
  }

  assign(newAssignee: SublimeEmployeeDTO){
    Application.startLoading();
    PRILService.assign(this.prilId, newAssignee.id!).then(
        ok => this.loadPRIL(),
        err => processError(err, this)
    )
  }

  showAddAdditionalFileModal(): void {
    this.$modal.show(
      AddPRILAdditionalFileModal,
      {
        prilId: this.prilId,
        onSuccess: () => this.loadPRIL()
      },
      {
        height: 'auto',
        width: '600px'
      }
    );
  }

  showChangeCompanyModal(): void {
    this.$modal.show(
      ChangeCompanyModal,
      {
        prilId: this.prilId,
        onSuccess: () => this.loadPRIL()
      },
      {
        height: 'auto',
        width: '600px'
      }
    );
  }

}
